//跨域代理前缀
const API_PROXY_PREFIX = '/gf-web'

const BASE_URL = process.env.NODE_ENV === 'development' ? API_PROXY_PREFIX : API_PROXY_PREFIX

module.exports = {
    //admin
    loginApi:`${BASE_URL}/loginByPwd`,
    findAlarmByPageApi:`${BASE_URL}/alarm/findAlarmByPage`,
    updateAlarmByStatusApi:`${BASE_URL}/alarm/updateAlarmByStatus`,
    findAllGroupByLevApi:`${BASE_URL}/alarm/findAllGroupByLev`,
    findAllGroupByAlarmTypeApi:`${BASE_URL}/alarm/findAllGroupByAlarmType`,
    findAlarmByIdApi:`${BASE_URL}/alarm/findAlarmById`,

    findDevByPageApi:`${BASE_URL}/dev/findDevByPage`,

    //电站上半部分
    findPowerFirstTopByApi:`${BASE_URL}/power/findPowerFirstTopBy`,
    //电站下半部分
    findPowerFirstDownByPageApi:`${BASE_URL}/power/findPowerFirstDownByPage`,

    findTopInfoByApi:`${BASE_URL}/zl/findTopInfoBy`,
    findEchartsByApi:`${BASE_URL}/zl/findEchartsBy`,

    findDpTopInfoByApi:`${BASE_URL}/dp/findTopInfoBy`,
    findDpEchartsBy:`${BASE_URL}/dp/findEchartsBy`,
    findSysBigBy:`${BASE_URL}/sys/findSysBigBy`,
    findSysProvinceBy:`${BASE_URL}/sys/findBigProvinceCityBy`,

    findPowerByApi:`${BASE_URL}/sys/findPowerBy`,

    findPowerInfoByIdApi:`${BASE_URL}/power/findPowerInfoById`,
    yunxingzhuangtaiByApi:`${BASE_URL}/power/yunxingzhuangtaiBy`,
    powerFindEchartsByApi:`${BASE_URL}/power/findEchartsBy`,

    findInfoByDevIdApi:`${BASE_URL}/dev/findInfoByDevId`,
    devFindEchartsBy:`${BASE_URL}/dev/findEchartsBy`,

    findWnUserByPageApi:`${BASE_URL}/wn/findWnUserByPage`,
    saveWnUserAndPoeweByApi:`${BASE_URL}/wn/saveWnUserAndPoeweBy`,
    findWnFeedbackByPageApi:`${BASE_URL}/wn/findWnFeedbackByPage`,

    findWnRepairByPageApi:`${BASE_URL}/wn/findWnRepairByPage`,
    findWnCanceByPageApi:`${BASE_URL}/wn/findWnCanceByPage`,
    findWnPowerByPageApi:`${BASE_URL}/wn/findWnPowerByPage`,
    PfindPowerInfoByIdApi:`${BASE_URL}/wn/findPowerInfoById`,
    findPowerYxztByEchartsApi:`${BASE_URL}/wn/findPowerYxztByEcharts`,

    findDevInfoByIdApi:`${BASE_URL}/wn/findDevInfoById`,

    findDevYxztByEchartsApi:`${BASE_URL}/wn/findDevYxztByEcharts`,


}
